// Project Imports
import { REACT_APP_INPUT_SOURCE_API_URL } from 'config';

const dashboard = 'dashboard';
const upload = 'upload';
const userDetails = 'user_details';
const organization = 'organization';
const incentiveProgram = 'incentive_program';
const pincode = 'pin_codes';
const roles = 'roles';
const modulePermissions = 'module_master_details';
const rolePermissions = 'role_permission_details';
const userEvalPermissionDetails = `user_eval_permission_details`;
const downloadTemplate = `${REACT_APP_INPUT_SOURCE_API_URL}/download_augment_user_excel/`;
const updateUserLanguage = 'update_user_language';
const getTimezoneList = 'get_timezone_list';
const userRoles = 'get_user_roles_program_details';
const updateUserRoleProgramDetails = 'update_user_role_program_details';
const inputSourceFileUpload = 'input_data_file_upload';
const downloadUserTemplateBaseUrl = `${REACT_APP_INPUT_SOURCE_API_URL}/download_augment_user_excel`;
const downloadUserTemplate = 'download_augment_user_excell';
const bulkUserBaseUrl = `${REACT_APP_INPUT_SOURCE_API_URL}/get_user_bulk_upload_data`;
const createSuperUser = 'create_super_user';
const workFlowStatus = 'work_flow_status';
const getProgramRoles = 'get_program_roles';
const templateDetails = 'template_details';
const audienceGrouping = 'audience_group';
const fetchSourceDetails = 'fetch_source_details';
const getContentVariables = 'get_content_variables';
const dataSourceColumnList = 'data_source_column_list';
const getAudienceGroupVariables = 'get_audience_group_variables';
const getCalculationVariables = 'get_calculation_variables';
const getTargetParameters = 'get_target_parameters';
const dataSourceColumnListWithNudge = 'get_nudge_column';
const userAttributeMasterMapping = 'user_attr_master_mapping';

const apiEndpoint = {
  dashboard,
  upload,
  organization,
  incentiveProgram,
  pincode,
  roles,
  modulePermissions,
  rolePermissions,
  userEvalPermissionDetails,
  downloadTemplate,
  updateUserLanguage,
  getTimezoneList,
  userRoles,
  updateUserRoleProgramDetails,
  inputSourceFileUpload,
  downloadUserTemplate,
  downloadUserTemplateBaseUrl,
  bulkUserBaseUrl,
  createSuperUser,
  userDetails,
  workFlowStatus,
  getProgramRoles,
  templateDetails,
  audienceGrouping,
  fetchSourceDetails,
  getContentVariables,
  dataSourceColumnList,
  getAudienceGroupVariables,
  getCalculationVariables,
  getTargetParameters,
  dataSourceColumnListWithNudge,
  userAttributeMasterMapping,
};

export default apiEndpoint;
